import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-findus',
    templateUrl: './findus.component.html',
    styleUrls: ['./findus.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FindusComponent {
}
